import { NgModule } from '@angular/core'
import { checkTime } from './checkTime'
import { SecondToTime ,timeFormat, weekFormate,convertSecond} from './minuits.pipe'
import { MathRoundPipe, SafeHtmlPipe, safeSrcPipe } from './shortname.pipe'

@NgModule({
  declarations: [SafeHtmlPipe, SecondToTime ,MathRoundPipe , safeSrcPipe,timeFormat,weekFormate ,checkTime,convertSecond],
  exports: [SafeHtmlPipe, SecondToTime , MathRoundPipe ,safeSrcPipe,timeFormat,weekFormate ,checkTime,convertSecond],
})
export class PipeModule {}
